export enum ChangeUserRoleModalAction {
  ADD_ADMIN = 'add_admin',
  REMOVE_ADMIN = 'remove_admin',
  ADD_MANAGER = 'add_manager',
  REMOVE_MANAGER = 'remove_manager',
}
